import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import qs from 'qs'

import PATHS from 'utils/paths'

import { QUIZ_DIAGNOSTICS_PARAMS } from '../utils/quizDiagnosticsParams'

const QuizDiagnosticsLegacyRedirect = (): JSX.Element => {
  const { search } = useLocation()
  const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })
  const chapterId = parsedQuery[QUIZ_DIAGNOSTICS_PARAMS.chapterId]

  if (typeof chapterId === 'string' && chapterId) {
    return <Redirect to={`${PATHS.sectionAverages}${search}`} />
  }

  return <Redirect to={PATHS.chapterAverages} />
}

export default QuizDiagnosticsLegacyRedirect
